import type {Commit} from '@github-ui/repos-types'
import React from 'react'

export interface CommitInfoState {
  commitInfo?: Record<string, Commit>
  loading?: boolean
  error?: boolean
}

const CommitInfoContext = React.createContext<CommitInfoState>({
  commitInfo: undefined,
  error: undefined,
  loading: false,
})

export function CommitInfoProvider({children, commitInfo, error, loading}: React.PropsWithChildren<CommitInfoState>) {
  const value = React.useMemo(() => ({commitInfo, error, loading}), [commitInfo, error, loading])
  return <CommitInfoContext value={value}>{children}</CommitInfoContext>
}

export function useCommitInfoContext() {
  return React.use(CommitInfoContext)
}
